// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Nh","sponsoredTooltipWrapper":"Oh","sponsoredTooltip":"Ph","newCard":"Qh"};